/* ODDAY Odd Quiz */
if (!customElements.get('odday-quiz')) {
  const SWC = ['#BB2921', '#377E7E', '#57BCBE', '#711109'];
  const shuffle = (a) => { a = [...a]; for (let i = a.length - 1; i > 0; i--) { const j = (Math.random() * (i + 1)) | 0; [a[i], a[j]] = [a[j], a[i]]; } return a; };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class OddayQuiz extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('[data-card]');
      this.startHTML = this.card.innerHTML;
      try { this.pool = JSON.parse(this.querySelector('[data-questions]').textContent).filter((q) => q.q); } catch (e) { this.pool = []; }
      try { this.types = JSON.parse(this.querySelector('[data-types]').textContent); } catch (e) { this.types = {}; }
      this.count = Math.min(parseInt(this.dataset.count, 10) || 5, this.pool.length);
      this.min = parseInt(this.dataset.min, 10) || 5;
      this.max = Math.max(this.min, parseInt(this.dataset.max, 10) || 10);
      this.bindStart();
    }
    bindStart() {
      this.card.querySelector('[data-start]')?.addEventListener('click', () => this.start());
    }
    start() {
      this.qs = shuffle(this.pool).slice(0, this.count);
      this.i = 0;
      this.score = { a: 0, s: 0, e: 0, r: 0 };
      this.show();
    }
    show() {
      const Q = this.qs[this.i];
      const opts = shuffle(Q.o.filter((o) => o[0]));
      const pct = (this.i / this.count) * 100;
      this.card.innerHTML = `
        <div class="odq-top"><span>Question ${this.i + 1} / ${this.count}</span><span style="color:var(--odd-red)">Odd Quiz</span></div>
        <div class="odq-bar"><i style="width:${pct}%"></i></div>
        <div class="odq-stage">
          <div class="odq-q">${esc(Q.q)}</div>
          <div class="odq-opts">${opts.map((o, k) => `<button type="button" class="odq-opt" data-t="${o[1]}"><span class="odq-sw" style="background:${SWC[k % 4]}">${'ABCD'[k]}</span>${esc(o[0])}</button>`).join('')}</div>
        </div>`;
      this.card.querySelectorAll('.odq-opt').forEach((b) => b.addEventListener('click', () => {
        if (this.locked) return;
        this.locked = true;
        b.classList.add('is-pick');
        this.score[b.dataset.t]++;
        this.card.querySelector('.odq-bar i').style.width = ((this.i + 1) / this.count) * 100 + '%';
        setTimeout(() => { this.locked = false; this.i++; this.i < this.count ? this.show() : this.result(); }, 420);
      }));
    }
    result() {
      const top = Object.entries(this.score).sort((a, b) => b[1] - a[1] || Math.random() - 0.5)[0][0];
      const T = this.types[top] || { n: 'Odd Legend', d: '', url: '/collections/all' };
      const pct = this.min + Math.floor(Math.random() * (this.max - this.min + 1));
      const code = `${this.dataset.prefix || ''}${pct}${this.dataset.suffix || ''}`;
      const tpl = this.querySelector('template[data-rec]');
      const rec = tpl ? tpl.content.querySelector(`[data-type="${top}"]`) : null;
      const redirect = T.url || '/cart';
      this.card.innerHTML = `
        <div class="odq-res odq-stage">
          <p class="odd-eyebrow">You are…</p>
          <div class="odq-type">${esc(T.n)}</div>
          <p class="odq-desc">${esc(T.d)}</p>
          <div class="odq-pct">${pct}% OFF</div>
          <div><div class="odq-code"><span>${esc(code)}</span><button type="button" data-copy>Copy</button></div></div>
          <div data-rec-slot></div>
          <div class="odq-actions">
            <a class="odd-btn odd-btn--ink" href="/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}">Apply &amp; shop →</a>
            <button type="button" class="odq-again" data-again>Play again</button>
          </div>
        </div>`;
      if (rec) this.card.querySelector('[data-rec-slot]').appendChild(rec.cloneNode(true));
      this.card.querySelector('[data-copy]').addEventListener('click', (e) => {
        navigator.clipboard?.writeText(code).catch(() => {});
        e.currentTarget.textContent = 'Copied!';
      });
      this.card.querySelector('[data-again]').addEventListener('click', () => { this.card.innerHTML = this.startHTML; this.bindStart(); });
      try { localStorage.setItem('odd-quiz-code', code); } catch (e) {}
      window.ODD?.confetti?.();
    }
  }
  customElements.define('odday-quiz', OddayQuiz);
}
